import getMadaiURL from '../domain/getMadaiURL';
import get_bundle from '../domain/get_bundle';

const madai_url = getMadaiURL();

export default function getConditions(locale) {
  function getHref() {
    return "https://madai.com/privacy_us.html"
    /*const _locale = locale.toString();
    const country = locale.country.toLowerCase();
    if (_locale === 'en_ZA') {
      return 'http://za.shop.madai.com/FAQ_en.html';
    } else if (_locale === 'en_US') {
      return 'http://us.shop.madai.com/FAQ_en.html';
    } else if (_locale === 'it_IT') {
      return 'http://it.madai.com/FAQ_it.html';
    }
    else {
      return madai_url + country + '/terms-of-use.html';
    }*/
  }
  return '<a target="_blank" href="' + getHref() + '">' + get_bundle(locale).footer.conditions + '</a>';
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/util/getConditions.js
 **/